import { PaginatedResponse } from '@repo/types';

export function useTableLocalPagination<T>(
  data: T[],
  page: number,
  limit: number
): PaginatedResponse<T> {
  const total = data.length;
  const totalPages = Math.ceil(total / limit);
  const start = (page - 1) * limit;
  const end = start + limit;

  return {
    data: data.slice(start, end),
    pagination: {
      page,
      limit,
      total,
      totalPages,
    },
  };
}
